module.exports = __webpack_public_path__ + "img/facilitysiting-min.247d54c3.jpg";